import React from "react";

const SendPasswordLink = (props) => {
  const {
    userToSend,
    sendResetPasswordAction
  } = props;

  return <button className="send-reset-password-button" onClick={
    (e) => {
      e.preventDefault();
      sendResetPasswordAction(userToSend)
    }
  }>Send Password Reset</button>
}

export default SendPasswordLink;